import { Injectable } from '@angular/core';
import { ProjectPage } from '@shared/models/project-page';
import { DynamicPageParams, PageDef } from './dynamic-page/models';

@Injectable()
export abstract class DocDynamicPageService {
  public abstract getDocDynamicPage(
    page: ProjectPage,
    pageDef: PageDef,
  ): Promise<DynamicPageParams>;
}
